// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper___E3LO","isLoginForm":"Wrapper_isLoginForm__pScjR","closeIcon":"Wrapper_closeIcon__SsUwM","mobileWrapper":"Wrapper_mobileWrapper__aQXiW"};